import { DashboardQuickActions } from '@/features/dashboard/components/DashboardQuickActions';
import { DashboardWalletCard } from '@/features/dashboard/components/DashboardWalletCard';
import { DashboardCampaignsOverviewCard } from '@/features/dashboard/components/DashboardCampaignsOverviewCard';
import { ClientPersonalAdvertiserPrompt } from '@/features/campaigns/components/ClientPersonalAdvertiserPrompt';
import { useAppSelector } from '@/shared/store/hooks';
import { getUserFirstName } from '@/shared/lib/user/displayName';
import { useIsClient } from '@/shared/hooks/useIsClient';
import { useIsTeamMember } from '@/shared/hooks/useIsTeamMember';

export function DashboardPage() {
  const user = useAppSelector((state) => state.auth.user);
  const firstName = getUserFirstName(user, 'there');
  const isClient = useIsClient();
  const isTeamMember = useIsTeamMember();
  const hideWallet = isClient || isTeamMember;

  return (
    <div className="mx-auto flex w-full max-w-6xl flex-col gap-6 sm:gap-7">
      <header className="text-left">
        <span className="mb-3.5 inline-flex w-fit items-center gap-1.5 rounded-full bg-[#DFE9FA] px-3 py-1.5 text-[11px] font-extrabold tracking-[1px] text-[#3B66B8] uppercase">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#3B66B8]" />
          Live network status
        </span>
        <h1 className="m-0 text-[26px] font-extrabold tracking-[-0.5px] text-[#3A3660] sm:text-[34px]">
          Welcome back, {firstName}
        </h1>
        <p className="mt-1.5 mb-0 text-[14px] text-[#6A6688]">
          {isClient
            ? 'Browse screens and track campaigns run for your brand.'
            : isTeamMember
              ? 'Manage campaigns for the clients assigned to you.'
              : "Here's what's happening across your screens today."}
        </p>
      </header>

      {isClient ? <ClientPersonalAdvertiserPrompt variant="banner" /> : null}

      <DashboardQuickActions />

      <div className={`grid grid-cols-1 gap-5 ${hideWallet ? '' : 'lg:grid-cols-[1fr_1.2fr]'}`}>
        {!hideWallet ? <DashboardWalletCard /> : null}
        <DashboardCampaignsOverviewCard />
      </div>
    </div>
  );
}
